import ReactMonacoEditor, { MonacoDiffEditor as ReactMonacoDiffEditor } from 'react-monaco-editor';

/**
 * Appends the specified editor instance to the array stored in 'window.veezoo.monaco.editors'.
 *
 * Also sets the 'window.veezoo.monaco.monaco' reference to the specified 'monaco' module, which is the same for every
 * editor instance.
 */
const addReference = (editor, monaco) =>
  (window.veezoo = {
    ...window.veezoo,
    monaco: {
      ...window.veezoo?.monaco,
      monaco,
      editors: [...(window.veezoo?.monaco?.editors || []), editor]
    }
  });

/**
 * Removes the specified editor instance from the array stored in 'window.veezoo.monaco.editors'.
 */
const removeReference = editor =>
  (window.veezoo.monaco.editors = window.veezoo.monaco.editors.filter(e => e.getId() !== editor.getId()));

/**
 * Wraps the 'MonacoEditor' component to keep track of the editor instance in 'window.veezoo.monaco.editors'.
 *
 * This is currently being used in end-to-end tests.
 */
export const MonacoEditor = ({ editorDidMount, editorWillUnmount, ...properties }) => (
  <ReactMonacoEditor
    {...properties}
    editorDidMount={(editor, monaco) => {
      addReference(editor, monaco);
      editorDidMount?.(editor, monaco);
    }}
    editorWillUnmount={(editor, monaco) => {
      removeReference(editor);
      editorWillUnmount?.(editor, monaco);
    }}
  />
);

/**
 * Wraps the 'MonacoDiffEditor' component to keep track of the editor instance in 'window.veezoo.monaco.editors'.
 *
 * This is currently being used in end-to-end tests.
 */
export const MonacoDiffEditor = ({ editorDidMount, editorWillUnmount, ...properties }) => (
  <ReactMonacoDiffEditor
    {...properties}
    editorDidMount={(editor, monaco) => {
      addReference(editor);
      editorDidMount?.(editor, monaco);
    }}
    editorWillUnmount={(editor, monaco) => {
      removeReference(editor);
      editorWillUnmount?.(editor, monaco);
    }}
  />
);
